<template>
  <login-selo>
    <template v-slot:formulario>
      <login-form></login-form>
    </template>
  </login-selo>
</template>

<script>
import LoginSelo from "./LoginSelo";
import LoginForm from "./Form";

export default {
  components: {
    LoginSelo,
    LoginForm,
  },

  mounted() {
    setTimeout(() => this.$notification.removeAll(), 10);
  },
};
</script>
